"use strict";

var isCallable = require("./object/is-callable");

module.exports = function (value) {
	try {
		if (value && isCallable(value.toString)) return value.toString();
		return String(value);
	} catch (e) {
		return "<Non-coercible to string value>";
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/safe-to-string.js
// module id = 242
// module chunks = 0